import HttpStatus from 'http-status-codes';

// all error will inherit from RbiError, which inherits from base Error
export class RbiError extends Error {
  public statusCode: number;

  constructor(message: string) {
    super(message);

    // by default, all errors will have a 500 code
    // in each error, this can be overridden as shown below
    this.statusCode = HttpStatus.INTERNAL_SERVER_ERROR;
  }
}

/**
 * Place generic, non-application specific errors here
 * For ease of maintenance, keep all errors alphabetical and self-documenting
 */

export class BrandNotSupportedError extends RbiError {
  constructor(brand: unknown) {
    super(`This functionality is not supported for Brand '${brand}'.`);
  }
}

export class CastError extends RbiError {
  /**
   * Object we tried to validate against a schema.
   * This property will only be populated if asked for.
   */
  public data?: unknown;

  /**
   * Schema validation errors.
   */
  public errors: string[];

  constructor(errors: string[], data?: unknown) {
    super(`Cast failed: ${errors.join(', ')}`);
    this.errors = errors;
    this.data = data;
    this.statusCode = HttpStatus.BAD_REQUEST;
  }
}

export class EnumMemberNotFoundError extends RbiError {
  public statusCode = HttpStatus.NOT_FOUND;

  constructor(receivedValue: string | number, expectedValues: Array<string | number>) {
    super(
      `Unknown enum value received: got ${receivedValue}, expected one of ${expectedValues.join(
        ' | ',
      )}`,
    );
  }
}

export class MissingRequiredParametersError extends RbiError {
  constructor(...parameters: any[]) {
    super(`Missing required parameters.  ${parameters.join()}`.trimRight());
    this.statusCode = HttpStatus.BAD_REQUEST;
  }
}

export class PosVendorMismatchError extends RbiError {
  constructor(value: any, ...expectations: string[]) {
    super(`The POS Vendor ${value} does not match expectations ${expectations.join()}.`);
    this.statusCode = HttpStatus.BAD_REQUEST;
  }
}

export class UnknownBrandError extends RbiError {
  constructor(brand: unknown) {
    super(`Brand '${brand}' is not known or not configured.`);
  }
}

export class UnknownRbiMessageQueueError extends RbiError {
  constructor(...parameters: any[]) {
    super(`No RBI message queue could be found using identifiers: ${parameters.join()}`);
  }
}

export class UnknownRbiMethodError extends RbiError {
  constructor(...parameters: any[]) {
    super(`No RBI method could be found using identifiers: ${parameters.join()}`);
  }
}

export class UnknownStageError extends RbiError {
  constructor(stage: unknown) {
    super(`Stage '${stage}' is not known or not configured.`);
  }
}

export class UnknownRegionError extends RbiError {
  constructor(region: unknown) {
    super(`Region '${region}' is not known or not configured.`);
  }
}
